module.exports = __webpack_public_path__ + "img/lg_ring_g_o_1_1.b935e2a1.png";